import useFetch from '@hooks/useFetch';
import { processTestSeriesData } from '@api/processors/testSeries';

const defaultTestSeriesLimit = 100;

export const getKey = (batchUID, limit = defaultTestSeriesLimit) =>
  `v1/batch/${batchUID}/test_series/?limit=${limit}`;

const useBatchTestSeries = (batchUID, limit = defaultTestSeriesLimit) => {
  const key = getKey(batchUID, limit);

  const { data: testSeries, ...rest } = useFetch(batchUID ? key : null);

  return {
    key,
    testSeries: testSeries?.results?.map(processTestSeriesData) || [],
    ...rest
  };
};

export default useBatchTestSeries;
